
/**
 * @see "Section 7.2.1, OFX Spec"
 */
export enum SynchronizationCapability {

  FULL,

  LITE
}
